import { render, staticRenderFns } from "./TranslationDomElements.vue?vue&type=template&id=4dee8079&"
import script from "./TranslationDomElements.js?vue&type=script&lang=js&"
export * from "./TranslationDomElements.js?vue&type=script&lang=js&"
import style0 from "./TranslationDomElements.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports